import Header from "../components/Header";
import Footer from "../components/Footer";

import {useTranslation} from 'react-i18next';

function Support() {
    const [t, i18n] = useTranslation("global");
return ( <>
        <Header />
        <section className="sectionPageContent">
            <h1>
                {t("pageTitle.support")} 
            </h1>    
        </section>
        <Footer />
        </>    );
}

export default Support;      